module.exports = __webpack_public_path__ + "media/images/user-sp-6587c202e6dcef8b02faefc2349f043d.svg";